module.exports = __webpack_public_path__ + "img/customProgramsRegistration.fc8d080a.png";